import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { PermissionsEnum } from "../constants/enums";
import { useAuthStore } from "../stores/authStore";
import { formatDisplayName } from "../utils/name";

const navItems = [
  { to: "/", label: "Home", end: true },
  { to: "/alerts", label: "Alerts" },
  { to: "/connect", label: "Connect" },
  { to: "/profile", label: "Profile" },
];

export const AppLayout = () => {
  const { claims, logout } = useAuthStore();
  const navigate = useNavigate();

  const roleLabel = claims?.permissions?.includes(PermissionsEnum.DOCTOR)
    ? "Doctor"
    : claims?.permissions?.includes(PermissionsEnum.CARE_GIVER)
      ? "Care Giver"
      : "Staff";

  const onLogout = () => {
    logout();
    navigate("/login", { replace: true });
  };

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="sidebar-brand">
          <img src="/logo.png" alt="REEVA" className="sidebar-logo" />
          <div>
            <div className="brand-name">REEVA Care</div>
            <div className="brand-role">{roleLabel}</div>
          </div>
        </div>
        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `sidebar-link${isActive ? " active" : ""}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="sidebar-footer">
          <div className="sidebar-user-block">
            <div className="sidebar-user">
              {formatDisplayName(claims?.first_name, claims?.last_name) ||
                "Staff"}
            </div>
            <div className="sidebar-user-role">{roleLabel}</div>
          </div>
          <button type="button" className="btn btn-ghost" onClick={onLogout}>
            Log out
          </button>
        </div>
      </aside>
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
};
